import { call, put, takeEvery } from "redux-saga/effects";
import { nhomLopApi } from "../../../api/category/nhomLopApi";
import { sinhVienApi } from "../../../api/category/sinhVienApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eStuNhomLopActionIds, IStuNhomLopActionTypes } from "../../action-types/category/IStuNhomLopActions";
import { rootActions } from "../../actions/rootActions";
import { IStuNhomLopCreateAutoRequest } from "../../../model/request/category/IStuNhomLopCreateAutoRequest";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IStuNhomLopUpdateCaHocRequest } from "../../../model/request/category/IStuNhomLopUpdateCaHocRequest";
import { IStuNhomLop } from "../../../model/respone/category/IStuNhomLop";
import { INhomLopCopyDuLieuTuKyTruocRequest } from "../../../model/request/category/INhomLopCopyDuLieuTuKyTruocRequest";
import { INhomLopGhepCapTuDongRequest } from "../../../model/request/category/INhomLopGhepCapTuDongRequest";
import { IStuNhomLopInsertRequest } from "../../../model/request/category/IStuNhomLopInsertRequest";
import { IStuNhomLopCreateFromCtdtRequest } from "../../../model/request/category/IStuNhomLopCreateFromCtdtRequest";
import { NotifyHelper } from "../../../helpers/toast";

export function* nhomLopSaga(): any {
  yield takeEvery(eStuNhomLopActionIds.LOAD_START, loadWorker);
  yield takeEvery(eStuNhomLopActionIds.PREVIEW_PHAN_NHOM_TU_DONG_START, previewWorker);
  yield takeEvery(eStuNhomLopActionIds.SAVE_PHAN_NHOM_TU_DONG_START, saveAutoWorker);
  yield takeEvery(eStuNhomLopActionIds.DELETE_START, deleteWorker);
  yield takeEvery(eStuNhomLopActionIds.UPDATE_CA_HOC_START, updateCaHocWorker);
  yield takeEvery(eStuNhomLopActionIds.UPDATE_START, updateWorker);
  yield takeEvery(eStuNhomLopActionIds.COPY_NHON_LOP_TU_KY_TRUOC_START, copyNhomLopTuKyTruocWorker);
  yield takeEvery(eStuNhomLopActionIds.GHEP_CAP_TU_DONG_START, ghepCapTuDongWorker);
  yield takeEvery(eStuNhomLopActionIds.INSERT_START, insertWorker);
  yield takeEvery(eStuNhomLopActionIds.CREATE_FROM_CTDT_START, createFromCtdtWorker);
}

function* loadWorker(action: IStuNhomLopActionTypes): any {
  const { nam_hoc, hoc_ky } = action.payload as { nam_hoc: string, hoc_ky: number };
  const res: IBaseRespone = yield call(nhomLopApi.SelectByHocKyAndNamHoc, nam_hoc, hoc_ky);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLop.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* previewWorker(action: IStuNhomLopActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopApi.PrevewAsync, action.payload as IStuNhomLopCreateAutoRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.PREVIEW_PHAN_NHOM_TU_DONG_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLop.PREVIEW_PHAN_NHOM_TU_DONG_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* saveAutoWorker(action: IStuNhomLopActionTypes): any {
  const request = action.payload as IStuNhomLopCreateAutoRequest;
  const res: IBaseRespone = yield call(nhomLopApi.PrevewAsync, request);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.SAVE_PHAN_NHOM_TU_DONG_SUCCESS(res.data));
    yield put(rootActions.category.lopNamHoc.REFRESH(undefined));
  } else {
    yield put(
      rootActions.category.nhomLop.SAVE_PHAN_NHOM_TU_DONG_ERROR(res.message ?? "Có lỗi")
    );
  }
}


function* deleteWorker(action: IStuNhomLopActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopApi.DeletesAsync, action.payload as IIdsRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.DELETE_SUCCESS(undefined));
    yield put(rootActions.category.lopNamHoc.REFRESH(undefined));
  } else {
    yield put(
      rootActions.category.nhomLop.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* updateCaHocWorker(action: IStuNhomLopActionTypes): any {
  const res: IBaseRespone = yield call(nhomLopApi.UpdateCaHocAsync, action.payload as IStuNhomLopUpdateCaHocRequest);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.UPDATE_CA_HOC_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLop.UPDATE_CA_HOC_ERROR(res.message ?? "Có lỗi")
    );
  }
}
function* updateWorker(action: IStuNhomLopActionTypes): any {
  const payload = action.payload as IStuNhomLop & { id_lops?: number[] };
  let updateBody: any = payload;
  // != null bắt cả null (grid spread row có id_lops=null từ BE) lẫn undefined -> bỏ qua,
  // tránh null.length làm crash saga khiến không gọi API update.
  if (payload.id_lops != null) {
    let sinhViens: any[] = [];
    if (payload.id_lops.length > 0) {
      const svRes: IBaseRespone = yield call(sinhVienApi.SelectByLops, payload.id_lops);
      if (!svRes.is_success) {
        yield put(rootActions.category.nhomLop.UPDATE_ERROR(svRes.message ?? "Không tải được danh sách sinh viên"));
        return;
      }
      sinhViens = (svRes.data ?? []).filter((x: any) => x.trang_thai === 0);
    }
    updateBody = { ...payload, sinhViens };
  }
  const res: IBaseRespone = yield call(nhomLopApi.Update, updateBody);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.UPDATE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.nhomLop.UPDATE_ERROR(res.message ?? "Có lỗi")
    );
  }
}
function* copyNhomLopTuKyTruocWorker(action: IStuNhomLopActionTypes): any {
  const request = action.payload as INhomLopCopyDuLieuTuKyTruocRequest;
  const res: IBaseRespone = yield call(nhomLopApi.CopyNhomLopTuKyTruocAsync, request);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.COPY_NHON_LOP_TU_KY_TRUOC_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.category.nhomLop.COPY_NHON_LOP_TU_KY_TRUOC_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* ghepCapTuDongWorker(action: IStuNhomLopActionTypes): any {
  const request = action.payload as INhomLopGhepCapTuDongRequest;
  const res: IBaseRespone = yield call(nhomLopApi.GhepCapTuDongAsync, request);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.GHEP_CAP_TU_DONG_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.category.nhomLop.GHEP_CAP_TU_DONG_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* createFromCtdtWorker(action: IStuNhomLopActionTypes): any {
  const request = action.payload as IStuNhomLopCreateFromCtdtRequest;
  const res: IBaseRespone = yield call(nhomLopApi.CreateFromCtdtAsync, request);
  if (res.is_success) {
    NotifyHelper.Success(`Đã tạo ${res.data ?? 0} nhóm lớp`);
    yield put(rootActions.category.nhomLop.CREATE_FROM_CTDT_SUCCESS(undefined));
  } else {
    yield put(
      rootActions.category.nhomLop.CREATE_FROM_CTDT_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* insertWorker(action: IStuNhomLopActionTypes): any {
  const request = action.payload as IStuNhomLopInsertRequest;
  let sinhViens: any[] = [];
  if (request.id_lops && request.id_lops.length > 0) {
    const svRes: IBaseRespone = yield call(sinhVienApi.SelectByLops, request.id_lops);
    if (!svRes.is_success) {
      yield put(rootActions.category.nhomLop.INSERT_ERROR(svRes.message ?? "Không tải được danh sách sinh viên"));
      return;
    }
    sinhViens = (svRes.data ?? []).filter((x: any) => x.trang_thai === 0);
  }
  const insertBody = {
    ...request,
    id: 0,
    sinhViens,
  };
  const res: IBaseRespone = yield call(nhomLopApi.Insert, insertBody);
  if (res.is_success) {
    yield put(rootActions.category.nhomLop.INSERT_SUCCESS(res.data));
  } else {
    yield put(rootActions.category.nhomLop.INSERT_ERROR(res.message ?? "Có lỗi"));
  }
}